import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OpticalModuleComponent } from './optical-module.component';
// import { AuthGuard } from './auth/auth-guard.service';


const opticalModuleroutes: Routes = [
    {path: '', component: OpticalModuleComponent}
]

@NgModule({
    imports: [
        RouterModule.forChild(opticalModuleroutes)
    ],
    exports: [RouterModule]
   })

export class OpticalModuleRoutingModule { }
